import BaseApi from "./BaseApi";
class PriestApi extends BaseApi {
  async getAllPriests(data) {
    return await this.API({
      url: "/auth/getAllPriests",
      data: data,
      method: "post",
    });
  }

  async getPriestDetail(data) {
    return await this.API({
      url: "/priest/getPriestDetail",
      data: data,
      method: "post",
    });
  }

  async checkPKPriest(data) {
    return await this.API({
      url: "/auth/checkPKPriest",
      data: data,
      method: "post",
    });
  }

  async createPriest(data) {
    return await this.API({
      url: "/auth/createPriest",
      data: data,
      method: "post",
    });
  }

  async editPriest(data) {
    return await this.API({
      url: "/auth/editPriest",
      data: data,
      method: "post",
    });
  }

  async deletePriest(data) {
    return await this.API({
      url: "/priest/deletePriest",
      data: data,
      method: "post",
    });
  }

  async checkPKPriest(data) {
    return await this.API({
      url: "/auth/checkPKPriest",
      data: data,
      method: "post",
    });
  }

  async participatedInRetreats(data) {
    return this.API({
      url: "/priest/participatedInRetreats",
      data: data,
      method: "post",
    });
  }
}

export default PriestApi;
